const locationsBreadcrumbsRoutes = {
  '/locations': null,
  '/locations/:companyId': 'Locations',
  '/locations/:companyId/location': null,
  '/locations/:companyId/location/:locationId': 'Location details',
};

export { locationsBreadcrumbsRoutes };
